import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "@fluentui/react";
import { panelS } from "../../../features/common/styles/panelStyles";
import { toggleOrdersReportPanel } from "../../../config/redux/client/clientActions";
import OrdersReportClientForm from "../forms/OrdersReportClientForm";
import { clearAlerts } from "../../../config/redux/alerts/alertsActions";

const OrdersReportPanel: React.FC = () => {
  const dispatch = useDispatch();
  const { ordersReportPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.client
  );

  const dismissPanel = () => {
    dispatch(clearAlerts());
    dispatch(toggleOrdersReportPanel({ isOpen: false }));
  };
  return (
    <Panel
      isOpen={ordersReportPanelOpen}
      closeButtonAriaLabel="Close"
      headerText="Raport"
      onDismiss={dismissPanel}
      type={1}
      onOuterClick={() => { }}
      isLightDismiss={false}
      styles={panelS}
      isHiddenOnDismiss={false}
      isFooterAtBottom={true}
    >
      <OrdersReportClientForm />
    </Panel>
  );
};

export default OrdersReportPanel;